import { render, staticRenderFns } from "./GameCardSkeleton.vue?vue&type=template&id=2fe57da1&scoped=true"
import script from "./GameCardSkeleton.vue?vue&type=script&lang=js"
export * from "./GameCardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./GameCardSkeleton.vue?vue&type=style&index=0&id=2fe57da1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe57da1",
  null
  
)

export default component.exports